export globalSettings from './global/handlers';
export userSettings from './user/handlers';



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/handlers.js